import { defineStore } from "pinia";
import {
  collection,
  query,
  getFirestore,
  getDocs,
  doc,
  setDoc,
  where,
  orderBy,
  limit
} from "firebase/firestore";
import { Ref, ref } from "vue";
import { userUserStore } from "../stores/user";
import { LogAcciones, logAccionesConverter } from "@fixeduy/restaurantestypes";

export const useLogAccionesStore = defineStore("logAcciones", () => {
  const db = getFirestore();
  const userStore = userUserStore();

  const logs: Ref<LogAcciones[]> = ref([]);
  /** Resultado de la consulta filtrada en el módulo Log acciones (no mutar al guardar logs en otras pantallas). */
  const logsConsulta: Ref<LogAcciones[]> = ref([]);
  const cargando = ref(false);
  const cargandoConsulta = ref(false);

  const getFromFirestore = async () => {
    const empresaId = userStore.empresa?.id;
    if (!empresaId) return;

    cargando.value = true;
    try {
      const collectionRoute = `empresas/${empresaId}/log-acciones`;
      const q = query(collection(db, collectionRoute)).withConverter(
        logAccionesConverter
      );

      const querySnapshot = await getDocs(q);
      logs.value = querySnapshot.docs.map(d => d.data());
    } finally {
      cargando.value = false;
    }
  };

  const guardarLog = async (log: LogAcciones): Promise<string | null> => {
    const empresaId = userStore.empresa?.id;
    if (!empresaId) return null;

    const collectionRoute = `empresas/${empresaId}/log-acciones`;
    const docRef = doc(collection(db, collectionRoute));
    log.id = docRef.id;
    cargando.value = true;
    try {
      await setDoc(docRef, log);
      logs.value.push(log);
      return docRef.id;
    } catch (error) {
      console.error("Error al crear producto:", error);
      return null;
    } finally {
      cargando.value = false;
    }
  };

  const init = async () => {
    await getFromFirestore();
  };

  const LIMITE_CONSULTA = 500;

  const buscarLogs = async (params: {
    modulo: LogAcciones["modulo"] | "";
    fechaDesdeMs: number;
    fechaHastaMs: number;
  }): Promise<void> => {
    const empresaId = userStore.empresa?.id;
    if (!empresaId) {
      logsConsulta.value = [];
      return;
    }

    cargandoConsulta.value = true;
    try {
      const collectionRoute = `empresas/${empresaId}/log-acciones`;
      const base = collection(db, collectionRoute).withConverter(
        logAccionesConverter
      );

      const constraints =
        params.modulo === ""
          ? [
              where("fecha", ">=", params.fechaDesdeMs),
              where("fecha", "<=", params.fechaHastaMs),
              orderBy("fecha", "desc"),
              limit(LIMITE_CONSULTA)
            ]
          : [
              where("modulo", "==", params.modulo),
              where("fecha", ">=", params.fechaDesdeMs),
              where("fecha", "<=", params.fechaHastaMs),
              orderBy("fecha", "desc"),
              limit(LIMITE_CONSULTA)
            ];

      const q = query(base, ...constraints);
      const snap = await getDocs(q);
      logsConsulta.value = snap.docs.map(d => d.data());
    } finally {
      cargandoConsulta.value = false;
    }
  };

  return {
    cargando,
    cargandoConsulta,
    init,
    guardarLog,
    getFromFirestore,
    logs,
    logsConsulta,
    buscarLogs
  };
});
